import React from "react";
import PropTypes from "prop-types";
import { InputField } from "../../FormField";
import moment from "moment";

const Part3 = ({ data }) => (
  <table
    style={{
      margin: "10px 0px",
      width: "100%",
      borderCollapse: "collapse",
      border: "1px solid #000",
    }}
  >
    <tbody>
      <tr>
        <td
          style={{
            fontWeight: "bold",
            backgroundColor: "#edb8be",
            paddingLeft: 10,
            borderBottom: "1px solid #000",
          }}
        >
          III)&nbsp;DEPENDANT(S) PARTICULARS - Complete this selection for your selected members:
        </td>
      </tr>
      <tr>
        <td>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    verticalAlign: "bottom",
                    width: 120,
                  }}
                  rowSpan={2}
                >
                  Relationship
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    verticalAlign: "bottom",
                  }}
                  rowSpan={2}
                >
                  Name (According to NRIC/Passport)
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    verticalAlign: "bottom",
                  }}
                  rowSpan={2}
                >
                  NRIC/ <br />
                  Passport No column
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    verticalAlign: "bottom",
                  }}
                  rowSpan={2}
                >
                  Gender
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    width: 180,
                  }}
                  colSpan={3}
                >
                  Date of Birth
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                  rowSpan={2}
                >
                  Height
                  <br />
                  (m)
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                  rowSpan={2}
                >
                  Weight
                  <br />
                  (kg)
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    width: 60,
                  }}
                >
                  DD
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    width: 60,
                  }}
                >
                  MM
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    width: 60,
                  }}
                >
                  YYYY
                </td>
              </tr>
              {data["SpouseName"] && !!data["SpouseName"].fieldValue && (
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Spouse
                  </td>
                  <td
                    id="RO_SpouseName"
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <InputField name={"SpouseName"} {...data["SpouseName"]} />
                  </td>
                  <td
                    id="RO_SpouseIdentification"
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <InputField name={"SpouseIdentification"} {...data["SpouseIdentification"]} />
                  </td>
                  <td
                    id="RO_SpouseGender"
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <InputField name={"SpouseGender"} {...data["SpouseGender"]} />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_SpouseBirthDateDay"
                  >
                    <InputField name={"SpouseBirthDateDay"} {...data["SpouseBirthDateDay"]} />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_SpouseBirthDateMonth"
                  >
                    <InputField
                      name={"SpouseBirthDateMonth"}
                      {...data["SpouseBirthDateMonth"]}
                      format={value =>
                        value &&
                        moment()
                          .month(value - 1)
                          .format("MM")
                      }
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_SpouseBirthDateYear"
                  >
                    <InputField name={"SpouseBirthDateYear"} {...data["SpouseBirthDateYear"]} />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <InputField
                      name={"SpouseHeight"}
                      {...data["SpouseHeight"]}
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <InputField
                      name={"SpouseWeight"}
                      {...data["SpouseWeight"]}
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
              )}
              {Array.of(
                { serverId: "First", number: 1, postfix: "st" },
                { serverId: "Second", number: 2, postfix: "nd" },
                { serverId: "Third", number: 3, postfix: "rd" },
                { serverId: "Fourth", number: 4, postfix: "th" },
                { serverId: "Fifth", number: 5, postfix: "th" },
                { serverId: "Sixth", number: 6, postfix: "th" },
                { serverId: "Seventh", number: 7, postfix: "th" },
                { serverId: "Eighth", number: 8, postfix: "th" },
                { serverId: "Ninth", number: 9, postfix: "th" },
                { serverId: "Tenth", number: 10, postfix: "th" }
              )
                .filter(
                  ({ serverId }) =>
                    data[`${serverId}ChildName`] && data[`${serverId}ChildName`].fieldValue
                )
                .map(({ serverId, number, postfix }) => (
                  <tr key={number}>
                    <td
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                        borderBottom: "1px solid #000",
                      }}
                    >
                      {number}
                      <sup>{postfix}</sup>
                      Child
                    </td>
                    <td
                      id="RO_FirstChildName"
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                        borderBottom: "1px solid #000",
                      }}
                    >
                      <InputField name={`${serverId}ChildName`} {...data[`${serverId}ChildName`]} />
                    </td>
                    <td
                      id="RO_FirstChildIdentification"
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                        borderBottom: "1px solid #000",
                      }}
                    >
                      <InputField
                        name={`${serverId}ChildIdentification`}
                        {...data[`${serverId}ChildIdentification`]}
                      />
                    </td>
                    <td
                      id="RO_FirstChildGender"
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                        borderBottom: "1px solid #000",
                      }}
                    >
                      <InputField
                        name={`${serverId}ChildGender`}
                        {...data[`${serverId}ChildGender`]}
                      />
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                        borderBottom: "1px solid #000",
                      }}
                      id="RO_FirstChildBirthDateDay"
                    >
                      <InputField
                        name={`${serverId}ChildBirthDateDay`}
                        {...data[`${serverId}ChildBirthDateDay`]}
                      />
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                        borderBottom: "1px solid #000",
                      }}
                      id="RO_FirstChildBirthDateMonth"
                    >
                      <InputField
                        name={`${serverId}ChildBirthDateMonth`}
                        {...data[`${serverId}ChildBirthDateMonth`]}
                      />
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                        borderBottom: "1px solid #000",
                      }}
                      id="RO_FirstChildBirthDateYear"
                    >
                      <InputField
                        name={`${serverId}ChildBirthDateYear`}
                        {...data[`${serverId}ChildBirthDateYear`]}
                      />
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                        borderBottom: "1px solid #000",
                      }}
                    >
                      <InputField
                        name={`${serverId}ChildHeight`}
                        {...data[`${serverId}ChildHeight`]}
                        style={{ width: 50 }}
                      />
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                        borderBottom: "1px solid #000",
                      }}
                    >
                      <InputField
                        name={`${serverId}ChildWeight`}
                        {...data[`${serverId}ChildWeight`]}
                        style={{ width: 50 }}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
);

Part3.propTypes = {
  data: PropTypes.shape({}),
};

export default Part3;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Ge/GEHDMOREDEP2018/Part3.js